import { colors } from '../../colors';
import { getBotColor } from '../../screens/Overview/ClusterItem/Charts/helpers';
import './index.css';
import { useCallback, useMemo, useState } from 'react';
import { AssetType, getAssetType } from 'grts-utils/types/AssetType';

interface Props {
  baseAsset: string;
  width?: string | number;
  height?: string | number;
  isHovering?: boolean;
  handleMouseEnter?: () => void;
  handleMouseLeave?: () => void;
  style?: any;
}

const AssetIcon: React.FC<Props> = (props: Props) => {
  const {
    baseAsset,
    width,
    isHovering,
    handleMouseEnter,
    handleMouseLeave,
    height,
    style,
  } = props;

  const [isUnableToLoad, setIsUnableToLoad] = useState(false);
  const [usePNG, setUsePNG] = useState(false);

  // Stock/commodity tokens are saved under their stripped ticker (e.g. tsla not
  // tslax/tslaon, slv not slvon) so every issuer variant shares one icon.
  const iconBaseAsset = useMemo(
    () =>
      getAssetType(baseAsset) === AssetType.Stock ||
      getAssetType(baseAsset) === AssetType.Commodity
        ? baseAsset.replace(/(ON|X)$/, '')
        : baseAsset,
    [baseAsset],
  );

  const resourceUrl = useMemo(
    () =>
      `/resources/icons/${iconBaseAsset.toLowerCase()}.${
        usePNG ? 'png' : 'svg'
      }`,
    [iconBaseAsset, usePNG],
  );

  const handleOnError = useCallback(() => {
    if (usePNG) {
      setIsUnableToLoad(true);
      return;
    }

    setUsePNG(true);
  }, [usePNG]);

  if (isUnableToLoad) {
    return (
      <div
        className="assetIconImage"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseOut={handleMouseLeave}
        style={{
          width: width ?? '40%',
          height: height ?? undefined,
          aspectRatio: 1,
          backgroundColor: getBotColor(baseAsset) || colors.gray,
          borderRadius: 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textDecoration: 'none',
          opacity: isHovering ? 0.1 : 1,
          ...style,
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: colors.white,
            textDecoration: 'none',
            pointerEvents: 'none',
          }}
        >
          {baseAsset.slice(0, 3)}
        </span>
      </div>
    );
  }

  return (
    <img
      src={resourceUrl}
      className="assetIconImage"
      width={width ?? '40%'}
      height={height ?? undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseOut={handleMouseLeave}
      style={{
        borderRadius: 100,
        opacity: isHovering ? 0.1 : 1,
        marginBottom: -6,
        ...style,
      }}
      onError={handleOnError}
    ></img>
  );
};

export default AssetIcon;
